import React, {useContext, useEffect, useRef, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom"
import { useDispatch } from "react-redux";
import { clear as clearForm1 } from "../redux/form1Slice";
import { clear as clearForm2 } from "../redux/form2Slice";
import { clear as clearForm3 } from "../redux/form3Slice";
import { clear as clearForm4 } from "../redux/form4Slice";

//パーツをインポート
import {PartsStep, PartsTutorialButton,} from "./parts"
import {SectionFlight, SectionPlan, SectionStay,} from "./section/PlanSelectTop"
import {SearchNotFound} from "./"

import TopSearchbox from "./search/TopSearchbox";

// MainTemplate
import MainTemplate from "./MainTemplate";

// scss
import "../scss/common.scss";
import "../scss/component.scss";

// for api
import {apiClient} from "../utils/apiClient";

// query parser
import qs from 'qs';

// types
import {IActivity} from "../types/Activity";
import {PlanSearch, searchResult} from "../types/Search";
import { AxiosResponse } from "axios";

// フライト
import {
  Flights,
  FlightType,
  FlightEntity,
  reservationFlight,
  viaReservationFlight,
  ReservationFlight,
  ViaReservationFlight,
  AirLines,
  FReservationFlightEntity,
  TravelType,
  Airline
} from "../types/Flight";

// ホテル
import {HotelAllSearchResponse, hotelSearchQuery, searchHotelParams, selectHotelDetail} from "../types/Hotel";
import {PlanSelectFormData, PlanSelectFromHotelType, PlanSelectFromFlightType} from "../types/planSelectForm";
import {FreeSpace} from "../types/Freespace";


// lib
import {dateFormat, rangeDate} from "../utils/convert"
import { ContactSupportOutlined } from "@material-ui/icons";
import {Seller} from "../types/seller";
import {
  getFlightCodeLabel,
  isNotCurrentFlights, checkUpdatedSelectFlights, getArrivalAirports, isFlightsLoading, isVacancy,
} from "../utils/flight";
import {
  checkHotel, getHotel,
  getHotelAreaCode,
  getHotelRoomPeopleLabel, getHotelSearchParams,
  scrollToHotelSection,
  sortRecommendHotels
} from "../utils/hotel";
import {checkActivityStockExist} from "../utils/plan";
import {sellerInfo} from "../types/sller";
import {defaultPlanSelectForm} from "../defaults/palnSelectForm";
import {checkSearchResult, getPlanSelectInfoData, initSearchParams} from "../utils/search";
import freeSpace from "./FreeSpace";
import FreeSpaceSection from "./FreeSpace";
import LoadingOverlay from "react-loading-overlay-ts";
import {getPlansTotalPrice, hasActivityStock} from "../utils/plan";
import {defaultBasicTotalPrice, getBasicTotalPrice} from "../utils/price";
import {actionAirline, airCode, anaHasNoFlightAirCode, jalHasNoFlightAirCode} from "../config/Airport";
import Error500 from "./error/Error500";
import WaitingRoom from "./WaitingRoom";
import {useWaitingRoom} from "../hooks/useWaitingRoom";
import {extendSession} from "../utils/waitingRoom";
import ServiceStop from "./ServiceStop";
import _ from "lodash";

import {getSearchURL} from "../utils/search";
import {validateFlightStartDate} from "../utils/validate";
import {devLog} from "../utils/errors";
import { sellerProductsType } from "../types/sellerProducts";
import {
  getCheepsFlight,
  getSearchFlightsRequestParams,
  sortFlights,
  getSelectedFlights, isChangeAirport,
  filterFlightTime
} from "../utils/flightV2";
import {searchFlights} from "../utils/useFlightApi";
import {
  currentFlightEntity,
  flightEntity,
  flightsEntity, FReservationFlight,
} from "../types/FlightV2";
import {defaultFlightEntities} from "../defaults/flight";
import { animateScroll as scroll } from 'react-scroll';
import {getHeadTitle} from "../utils/title";
import {FormSessionContext, FormSessionType} from "../hooks/FormSession";
import dayjs from "dayjs";
import {TagManagerContext, TagManagerType} from "../hooks/GTM";
import {siteTitle} from "../config/main";
import {getHotelSort} from "../utils/hotel/getHotelSort";
import { useTranslation } from "react-i18next";
import {langPath} from "../utils/lang";


/**
 * フライトの再読み込みが**例外で終わった**ときに使う待ち秒数（秒）。
 * サーバー指示（サーキットブレーカの遮断残り時間）を受け取れないため、既定値を使う。
 */
const DEFAULT_FLIGHT_RETRY_AFTER_SEC = 20;

const PlanSelectPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const tagManagerContext: TagManagerType = useContext(TagManagerContext);
  const dispatch = useDispatch();
  // use navigate
  const navigate = useNavigate();

  // 検索ボックスのパラメータ
  const search = useLocation().search.slice(1);
  const [searchParams, setSearchParams] = useState<PlanSearch>(initSearchParams(search));
  const [searchLoading, setSearchLoading] = useState(true);
  const [planType, setPlanType] = useState("");
  let notFound = false;
  if (!validateFlightStartDate(searchParams.start)) {
    notFound = true;
  }

  // is loading for any sections, you can add new loading value for section
  const [isLoadingComprehenshive, setLoadingComprehenshive] = useState(false);
  const [isLoadingFlight, setLoadingFlight] = useState({
    all: true,
    ANA: true,
    JAL: true
  });
  const [isLoadingHotel, setLoadingHotel] = useState(true);
  const [isListLoading, setIsListLoading] = useState(false);
  const [planSelectFormData, setPlanSelectFormData] = useState<PlanSelectFormData>(defaultPlanSelectForm);
  const [is500Error, setIs500Error] = useState(false);
  const [isNotFound, setIsNotFound] = useState(notFound);
  /**
   * ホテル一覧の「上流障害」状態（issue #2992 / 報告書 §8 No.4）。
   * undefined なら正常。設定されていれば「取得できませんでした＋再読み込み」を出す。
   * ★「検索結果なし」(isNotFound) とは別物。混同すると利用者が条件を変えて検索し直し、
   *   そのぶん上流コールが増える。
   */
  const [hotelError, setHotelError] = useState<{retryAfterSec: number} | undefined>(undefined);
  /** アクティビティ（基本プラン）区画の上流障害。全画面 Error500 にはしない。 issue #2992 */
  const [planError, setPlanError] = useState<{retryAfterSec: number} | undefined>(undefined);
  /** `/plan` を取得し直した回数。SectionPlan の key に使って在庫取得をやり直させる（§1-3） */
  const [planFetchCount, setPlanFetchCount] = useState(0);
  /** 再読み込み用に直近のホテル検索条件を保持する。 issue #2992 */
  const lastHotelQueryRef = useRef<hotelSearchQuery | undefined>(undefined);
  /**
   * フライト区画の上流障害（issue #2992・レビュー指摘）。
   * ★初回のトップ表示でも `/air/flights-search` の `errors` を読む。
   *   読まないと、取得できなかった区間が「該当便なし」として表示される
   *   （モーダル側（FlightModalApi）だけ対応していて初回表示が抜けていた）。
   *
   * ★これは**全社とも便を出せていない**ときだけ立てる（2026-09-04 T3・条件 A）。
   *   1 社だけ失敗した場合は `flightAirlineErrors`（条件 B）、便が出ているなら何も出さない（条件 C）。
   */
  const [flightError, setFlightError] = useState<{retryAfterSec: number} | undefined>(undefined);
  /**
   * 航空会社ごとの取得失敗（2026-09-04 T3・条件 B）。
   * ★「その社は 0 便＋errors あり／もう 1 社は便あり」のとき、その社のタブ内にだけ
   *   再読み込みを出す。区画全体を潰すと、取れている社の便まで見えなくなる。
   */
  const [flightAirlineErrors, setFlightAirlineErrors] =
    useState<{[airline: string]: {retryAfterSec: number}}>({});
  /** 初回ホテル取得の遅延タイマー。画面遷移時に止める。 issue #2992 */
  const initialHotelTimerRef = useRef<ReturnType<typeof setTimeout>>();
  const [isPlan, setIsPlan] = useState(true);
  const [isSearchBox, setIsSearchBox] = useState(false);

  const [logo, setLogo] = useState<string|undefined>(undefined);

  // get url params
  const urlParams = useParams<{ id: string }>();

  /**
   * 入場制御（待合室）のガード。 issue #2992 / 報告書 §8 No.11
   *
   * ★待合室が OFF（既定）なら `isWaiting` は常に false ＝ 画面はいっさい変わらない。
   *   対象外のプランも即時トークンが返るため待機画面は出ない。
   *   URL は維持したまま待機画面に差し替える（戻ってきたときに同じページを開ける）。
   */
  // ★判定はページ到達直後に要るので、URL から取れるプランIDだけを送る（`targetPlanIds`）。
  //   事業者IDの許可リスト（`targetSellerIds`）は削除した（2026-09-03 再レビュー R6）。
  //   事業者IDはクライアントの自己申告でしか届かず、送らなければ誰でも対象外にできたため。
  const waitingRoom = useWaitingRoom(urlParams.id);

  // 包括オプション
  const [activities, setActivities] = useState<IActivity[]>([]);

  // 宿泊施設(ホテル)
  const [actionHotel, setActionHotel] = useState(false);
  const [hotelAllData, setHotelAllData] = useState<HotelAllSearchResponse>({
    total: 0,
    currentPage: 0,
    totalPage: 0,
    search_sort: 0,
    status: 0,
    success: true,
    error: undefined,
    hotelList: [],
    subAreaCodes: "",
    hotelTypeCodes: "",
  }); // ホテル一覧で取得したデータ
  const [actionInitHotel, setActionInitHotel] = useState(false);
  const [updateHotelSearchParams, setHotelSearchParams] = useState<hotelSearchQuery>({
    area_code: '',
    target: '',
    code: '',
    search_sort: 0,
    query: searchParams,
  })


  // フライトと宿泊の表示非表示（選択できるできないのhandle）
  const [canSelect, setCanSelect] = useState(false);
  const [sellerId, setSellerId] = useState<string|undefined>(undefined);
  const [sellerInfo, setSellerInfo] = useState<sellerInfo|undefined>(undefined);

  // entities
  const [currentFlightEntities, setCurrentFlightEntities] = useState<currentFlightEntity[]>([])
  /**
   * `currentFlightEntities` の最新値（描画のたびに同期する）。 2026-09-04 再レビュー F3
   * ★1 社だけの再読み込みは `await` を挟むため、クロージャが掴んだ配列は古くなる。
   *   その間にもう 1 社で便を変更されると、完了時に**その変更を捨ててしまう**。
   */
  const currentFlightEntitiesRef = useRef<currentFlightEntity[]>([]);
  useEffect(() => {
    currentFlightEntitiesRef.current = currentFlightEntities;
  }, [currentFlightEntities]);
  const [flightEntities, setFlightEntities] = useState<flightsEntity>(defaultFlightEntities)

  // 各航空会社が就航していない区間ならtrueになる
  const [ anaHasNoFlight, setAnaHasNoFlight ] = useState(false);
  const [ jalHasNoFlight, setJalHasNoFlight ] = useState(false);
  const [ canFlight, setCanFlight ] = useState(false);
  const [ currentAirline, setCurrentAirline ] = useState("ANA");


  // ホテル検索のエリア指定で使用する
  const [selectedHotelAreaCode, setSelectedHotelAreaCode] = useState<string[]>([]);
  const [selectedHotelTypeCode, setSelectedHotelTypeCode] = useState<string[]>([]);

  const { checkSession, clearAllFormData } = useContext(FormSessionContext);

  // 検索
  const handleSearch = (q: PlanSearch) => {
    setSearchParams({...q})
    window.location.href = getSearchURL(q);
  }

  /**
   * フリースペース
   */
  const [freeSpaceContent, setFreeSpaceContent] = React.useState<FreeSpace>();
  useEffect(() => {
    // ★入場が確定するまで呼ばない（2026-09-07 再レビュー）。
    //   待機中に叩くと、並んでいる人ぶんの `/freeSpace` が上流へ流れる（`/plan` と同じ扱い）
    if (waitingRoom.isChecking || waitingRoom.isWaiting) {
      return;
    }
    // フリースペース取得（ローディング無し）
    (async () => {
      if (searchParams.to !== "") {
        await apiClient.post("/freeSpace", JSON.stringify({
          "plan": urlParams.id,
          isServiceInsurance: planSelectFormData.planData?.product?.serviceInsuranceSettings?.status === "enabled",
          serviceInsurance: {
            arrivalAirport: searchParams.to,
            tripStartDate: searchParams?.start
          }
        }))
          .then(function (response) {
            const data = response.data.freeSpace;
            const adminData = response.data.adminFreeSpace;
            const okinawaSaihakkenData = response.data.okinawaSaihakkenFreeSpace;
            const serviceInsuranceData = response.data.serviceInsuranceFreeSpace
            const updatePlanSelectFormData = planSelectFormData
            if (data || adminData || okinawaSaihakkenData) {
              updatePlanSelectFormData.freeSpace = {
                freeSpace: data.body,
                adminFreeSpace: adminData.body
              }

              // 全国割のフリースペース表示設定
              if (okinawaSaihakkenData.body.freeSpaceStatus === "enabled") {
                // 導入事業者別の表示設定
                if (planSelectFormData.planData?.sellerIndo?.discountSettings?.okinawaSaihakkenFreeSpace === "enabled") {
                  updatePlanSelectFormData.freeSpace.okinawaSaihakkenFreeSpace = okinawaSaihakkenData.body;
                }
              }
              
              if (serviceInsuranceData) {
                updatePlanSelectFormData.freeSpace.serviceInsuranceFreeSpace = serviceInsuranceData;
              }

              setFreeSpaceContent({...updatePlanSelectFormData.freeSpace})
              setPlanSelectFormData((prevState) => (
                {
                  ...prevState,
                  freeSpace: updatePlanSelectFormData.freeSpace,
                }))
            }
          })
          .catch(function (error) {
            // フリースペースは表示補助の情報。取得できなくても手続きは続けられるため、
            // 全画面 Error500 にはしない（issue #2992 / 報告書 §8 No.4）
            console.log(error);
          });
      }
    })();
  },[searchParams, waitingRoom.isChecking, waitingRoom.isWaiting])

  /**
   * 初回実行処理
   */
  useEffect(() => {
    // form1〜4の保存データを消去する
    dispatch(clearForm1());
    dispatch(clearForm2());
    dispatch(clearForm3());
    dispatch(clearForm4());
    // sessionStorageからも全フォームデータをクリア
    clearAllFormData();

    setPlanSelectFormData((prevState) => (
      {...prevState,
        id : urlParams.id?? "",
        info: getPlanSelectInfoData(searchParams),
        searchParams: searchParams,
      }
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * 入場が確定してからの初回取得。 issue #2992 / 報告書 §8 No.11・レビュー指摘
   *
   * ★入場制御の判定中／待機中は上流を叩かない。
   *   叩くと、待たせているはずの利用者が `/plan` を呼んで 401 になり、その `planError` が
   *   入場後も残る。さらに空依存の effect は再実行されないため、入場しても自動で取得が
   *   再開しなかった（レビュー指摘）。
   *
   * ★手続き制限時間の起点も**入場してから**にする。
   *   待合室で 40 分待った人の絶対上限（60 分）が残り 20 分になってしまうため
   *   （待合室は「順番待ち」であって「手続き中」ではない）。
   */
  const startedRef = useRef(false);
  useEffect(() => {
    if (waitingRoom.isChecking || waitingRoom.isWaiting || startedRef.current) {
      return;
    }
    startedRef.current = true;

    setPlanSelectFormData((prevState) => (
      {...prevState,
        // timestamp は「最後に操作した時刻」（checkSession のたびに更新される）。
        // sessionStartedAt は「手続き開始時刻」で、絶対上限の判定に使うため更新しない。
        // issue #2992 / 報告書 §8 No.9
        timestamp: dayjs().format(),
        sessionStartedAt: dayjs().format()
      }
    ));

    fetchPlan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waitingRoom.isChecking, waitingRoom.isWaiting]);

  /** アンマウント時に初回ホテル取得のタイマーを止める（issue #2992・レビュー指摘） */
  useEffect(() => () => {
    if (initialHotelTimerRef.current) {
      clearTimeout(initialHotelTimerRef.current);
      initialHotelTimerRef.current = undefined;
    }
  }, []);

  /**
   * 基本プラン（/plan）の取得。
   * ★区画別の再読み込み（issue #2992 / 報告書 §8 No.4）から再呼び出しできるよう関数に切り出した。
   *   失敗してもページ全体ではなく、この区画だけを再要求する。
   */
  const fetchPlan = (force = false) => {
    (async () => {
      // ★`force` は区画の「再読み込み」から呼ばれる。
      //   部分成功（取れた分だけ activities に入っている）だと `activities.length <= 0` の
      //   ガードに掛かって再取得できなかった（issue #2992・レビュー指摘）
      if(force || activities.length <= 0) {
        setPlanError(undefined);
        setLoadingComprehenshive(true)
        const response = await apiClient.post("/plan", JSON.stringify({
          "plan" : urlParams.id,
          "use_date" : searchParams?.start,
          "end_date" : searchParams?.end,
          "to": searchParams?.to,
          "language_code": i18n.language
        }))
          .then(function (response) {
            setLoadingComprehenshive(false);
            // ★HTTP 200 でも一部のアクティビティが取れていないことがある
            //   （サーバーは「取れた分 + errors」で 200 を返す）。
            //   読まないと、欠けたプランが無言で消え、全件失敗なら「該当なし」になる
            //   （issue #2992・レビュー指摘）
            const planErrors: string[] = response.data?.errors ?? [];
            if (planErrors.length > 0) {
              setPlanError({retryAfterSec: response.data?.retryAfterSec ?? 0});
              // ★全件失敗（200 + errors・plans 空）でもローダーを止める（§1-2）。
              //   止めないと再読み込みボタンに到達できない
              if (!(response.data?.plans?.length > 0)) {
                setSearchLoading(false);
              }
            }
            const results = response.data['plans'];
            const resultsOptions = response.data['options'];
            const data = results as IActivity[];
            if (response.data.info.status === 200) {
              // 孤児 comprehensive（productId 無しの古いレコード等）対策：
              // codes 空 かつ product が null の場合は孤児とみなし ServiceStop を表示
              if (!response.data.info.body?.codes && !response.data.product) {
                setIsPlan(false);
                return;
              }
              const logoImage = response.data.sellerIndo.companyInfo.logo;
              const type = response.data.info.body.type?? "option";
              const arrival = response.data.sellerIndo.useAirport.arrival;
              setLogo(logoImage);
              searchParams.to = arrival;
              searchParams.c_airport_from = arrival;

              // 基本プランに商品が設定されている場合、商品のデータを使用する
              if (response.data.product) {
                const productData: sellerProductsType = response.data.product;
                const searchBox = productData.searchBox || "enabled";
                searchParams.to = productData.useAirport.arrival;
                searchParams.from = productData.useAirport.departure ?? "HND";
                searchParams.c_airport_from = productData.useAirport.arrival;
                
                if (searchBox === 'enabled') {
                  setIsSearchBox(true);
                }
              }

              setPlanSelectFormData((prevState) => (
                {
                  ...prevState,
                  activity: data,
                  planData: response.data,
                  options: resultsOptions,
                  logo: logoImage?? "",
                  planType: type,
                  searchParams:searchParams,
                  sellerProduct: response.data.product,
                  isCoupons: response.data.isCoupons,
                  lang: i18n.language
                }))
              setActivities(data);
              // ★再取得のたびに SectionPlan を作り直させる（§1-3）
              setPlanFetchCount((prev) => prev + 1);
              setSellerId(response.data.info.body.userId)
              setPlanType(type);
              setSellerInfo(response.data.sellerIndo);
              setSearchParams({...searchParams});
              if (type === "option") {
                setCanSelect(true);
              }
              if (response.data.sellerIndo.active === '停止中') {
                setIsPlan(false);
              }
            } else {
              setIsPlan(false);
            }
          })
          .catch(function (error) {
            // ★全画面 Error500 にしない（issue #2992 / 報告書 §8 No.4）。
            //   混雑時に /plan が落ちるとページごと再読み込みされ、1人あたり約20回
            //   （OTS 約10 ＋ フライト約10）の上流コールが再発生していた（2026-08-31 実測）。
            //   区画（基本プラン）のエラー表示に留め、その区画だけ再読み込みできるようにする。
            //   Error500 はネットワーク断など、ページとして成立しない場合のみ。
            console.log(error);
            setPlanError({retryAfterSec: error?.response?.data?.retryAfterSec ?? 0});
            setLoadingComprehenshive(false);
            // ★スピナーを必ず止める（2026-09-03 レビュー §1-2）。
            //   setSearchLoading(false) はフライト取得の effect（planData 必須）にしか無く、
            //   /plan が失敗すると**永久にローダーのまま**で再読み込みボタンにも到達しなかった
            setSearchLoading(false);
          });
      }
    })();
  };
  
  useEffect(() => {
    if (planSelectFormData && sellerId) {
      const title = getHeadTitle(planSelectFormData, undefined)
      if (title !== siteTitle) {
        const title = getHeadTitle(planSelectFormData, undefined)
        tagManagerContext.pageView(title)
      }
    }
  }, [sellerId])

  /**
   * フライト検索
   */
  useEffect(() => {
    setPlanSelectFormData((prevState) => (
      {...prevState,
        info: getPlanSelectInfoData(searchParams)
      }
    ));
    // 基本プラン取得後にフライト情報取得
    if (searchParams !== undefined && planSelectFormData.planData !== undefined && currentFlightEntities.length === 0) {
      setActionHotel(true);
      (async () => {
        setSearchLoading(false);
        try {
          await updateFlights(undefined, searchParams);
        } catch (error) {
          // ★例外でもローディングを必ず解除する（2026-09-07 再レビュー）。
          //   解除しないと `isLoadingFlight.all` が立ちっぱなしになり、
          //   ホテルの選択も「次へ」も止まったままになる（selectDisabled）
          devLog(error);
          setFlightError({retryAfterSec: DEFAULT_FLIGHT_RETRY_AFTER_SEC});
        } finally {
          setLoadingFlight((prevState) => ({
            ...prevState,
            all: false,
          }))
        }
      })();
    }
  }, [searchParams])

  /**
   * フライト情報取得
   */
  const updateFlights = async (
    notUpdateFlight: {action: string, airline: string, currentFlights:FReservationFlight[]} | undefined,
    search: PlanSearch,
    /**
     * 起点にする配列。省略すると現在の値から積み増す（＝便の変更時の従来動作）。
     * ★再読み込み（`retryFlights`）は必ず空配列から作り直す（2026-09-03 レビュー §1-4）。
     *   現在値から積むと `updateCurrentFlightEntities` の push で ANA/JAL が重複し、
     *   `getSelectedFlights` が往復 2 組を返して**予約データに便が二重に入る**。
     */
    baseEntities?: currentFlightEntity[],
    /**
     * 引き直す航空会社を 1 社に絞る（省略すると全社）。
     * ★「その社だけ 0 便＋errors あり」の再読み込み（条件 B）で使う。
     *   もう 1 社の便と選択状態を維持したまま、失敗した社だけ上流へ問い合わせる。
     */
    onlyAirline?: string,
  ) => {
    let _currentFlightEntities = baseEntities ?? currentFlightEntities;
    const useAirline = planSelectFormData.sellerProduct?.useAirlineSettings?.status ?? 'all';
    /**
     * ★取得結果を**航空会社ごと**に持つ（issue #2992 / 2026-09-04 T3 の条件変更）。
     *
     *   以前は `errors` が 1 件でもあれば区画に再読み込みを出していたため、
     *   経由便やクラス J の 1 単位が落ちただけで、**便が並んでいるのに**
     *   「一部の便を取得できませんでした」が出て紛らわしかった。
     *
     *   `hasFlights` は「往路・復路がそろって取れた＝タブに便が出る状態」。
     *   片道しか取れていない場合は便を選べないので 0 便として扱う。
     */
    const airlineResults: {airline: string, hasFlights: boolean, hadError: boolean, retryAfterSec: number}[] = [];
    
    /**
     * 取得結果を state へ反映する。
     *
     * ★1 社だけ引き直したとき（`onlyAirline`）は**その社のぶんだけ差し替える**
     *   functional update にする（2026-09-04 再レビュー F3）。配列ごと置き換えると、
     *   再読み込み中にもう 1 社で行われた便の変更が捨てられる。
     */
    const mergeEntities = (prev: currentFlightEntity[], next: currentFlightEntity[]): currentFlightEntity[] => {
      if (!onlyAirline) {
        return [...next];
      }
      return [
        ...prev.filter((entity) => entity.airline !== onlyAirline),
        ...next.filter((entity) => entity.airline === onlyAirline),
      ];
    };

    const applyFlightEntities = (next: currentFlightEntity[]) => {
      setCurrentFlightEntities((prev) => mergeEntities(prev, next));

      // 派生値は「反映後の配列」から作り直す（ref は描画のたびに同期している）
      const merged = mergeEntities(currentFlightEntitiesRef.current, next);
      const selectFlights = getSelectedFlights(merged);
      setPlanSelectFormData((prevState) => ({
        ...prevState,
        flight: selectFlights,
      }));
      if (selectFlights && selectFlights.length > 0) {
        setCanFlight(true);
      }
      // ★1 社だけの再読み込みでは `all` を触らない（区画全体をローディング表示にしない）
      const loading = isFlightsLoading(merged);
      setLoadingFlight((prevState) => (onlyAirline ? {
        ...prevState,
        ANA: onlyAirline === "ANA" ? loading.ANA : prevState.ANA,
        JAL: onlyAirline === "JAL" ? loading.JAL : prevState.JAL,
      } : loading));
    };

    if (useAirline === 'JAL') {
      setCurrentAirline('JAL');
    }
    
    for(const [index, airline] of actionAirline.entries()) {
      // ★1 社だけ引き直すときは他社に触れない（条件 B の再読み込み）
      if (onlyAirline && airline.name !== onlyAirline) {
        continue;
      }

      // フライト情報取得
      const flights: { inbound: flightEntity, outbound: flightEntity } = {
        inbound: {
          flights: [],
          cheepsIndex: 0
        },
        outbound: {
          flights: [],
          cheepsIndex: 0
        }
      }
      
      if ( useAirline === 'all' || airline.name === useAirline) {
        const flightsRequestPrams = getSearchFlightsRequestParams(search, airline.name);
        const response = await searchFlights(flightsRequestPrams);

        const partial = (response.errors?.inbound?.length ?? 0) + (response.errors?.outbound?.length ?? 0);
        const hadError = partial > 0 || response.status !== 200;

        if (response.status === 200) {
          // 日程ソート
          flights.inbound.flights  = sortFlights(response.inbound?.FReservationFlights);
          flights.outbound.flights = sortFlights(response.outbound?.FReservationFlights);

          // フライト時間制御チェック(絞り込み)
          const filteredInboundFlights = filterFlightTime(flights.inbound.flights, planSelectFormData.sellerProduct?.arrivalTimeControl, "arrival");
          const filteredOutboundFlights = filterFlightTime(flights.outbound.flights, planSelectFormData.sellerProduct?.departureTimeControl, "departure");
          flights.inbound.flights = filteredInboundFlights;
          flights.outbound.flights = filteredOutboundFlights;

          // 最安の取得
          const inboundCheeps = getCheepsFlight(airline.name, flights.inbound.flights,search.roomDetail);
          flights.inbound.cheepsIndex = inboundCheeps.index;
          const outboundCheeps = getCheepsFlight(airline.name, flights.outbound.flights,search.roomDetail);
          flights.outbound.cheepsIndex = outboundCheeps.index;
        }

        // ★この社の判定材料を残す。A〜D の判定はループ後にまとめて行う
        airlineResults.push({
          airline: airline.name,
          hasFlights: flights.inbound.flights.length > 0 && flights.outbound.flights.length > 0,
          hadError: hadError,
          retryAfterSec: response.retryAfterSec ?? 0,
        });
      }
      
      let currentFlight: currentFlightEntity[] = [];

      switch (airline.name) {
        case "ANA":
          if (flights.inbound.flights.length > 0 && flights.outbound.flights.length > 0) {
            const inboundVacancy = isVacancy(airline.name, flights.inbound.flights[flights.inbound.cheepsIndex].FReservationFlight[0], search.roomDetail);
            const outboundVacancy = isVacancy(airline.name, flights.outbound.flights[flights.outbound.cheepsIndex].FReservationFlight[0], search.roomDetail);
            if (inboundVacancy && outboundVacancy) {
              setFlightEntities(prevState => ({...prevState,
                ANA: flights
              }));
              _currentFlightEntities = updateCurrentFlightEntities(flights, airline.name, notUpdateFlight, _currentFlightEntities, useAirline);
              setAnaHasNoFlight(false);
            } else {
              setAnaHasNoFlight(true);
            }
          } else {
            // ★state 配列を直接 push しない（2026-09-03 再レビュー R1）。
            //   同じ航空会社が既にあれば置き換える（再読み込みで重複させない）
            _currentFlightEntities = [
              ..._currentFlightEntities.filter((e) => e.airline !== airline.name),
              {airline: airline.name, inbound: [], outbound: [], current: false},
            ];
            setAnaHasNoFlight(true);
          }
          break;
        case "JAL":
          if (flights.inbound.flights.length > 0 && flights.outbound.flights.length > 0) {
            const inboundVacancy = isVacancy(airline.name, flights.inbound.flights[flights.inbound.cheepsIndex].FReservationFlight[0], search.roomDetail);
            const outboundVacancy = isVacancy(airline.name, flights.outbound.flights[flights.outbound.cheepsIndex].FReservationFlight[0], search.roomDetail);
            if (inboundVacancy && outboundVacancy) {
              setFlightEntities(prevState => ({...prevState,
                JAL: flights
              }));
              _currentFlightEntities = updateCurrentFlightEntities(flights, airline.name, notUpdateFlight, _currentFlightEntities, useAirline);
              setJalHasNoFlight(false);
            } else {
              setJalHasNoFlight(true);
            }
          } else {
            // ★state 配列を直接 push しない（2026-09-03 再レビュー R1）
            _currentFlightEntities = [
              ..._currentFlightEntities.filter((e) => e.airline !== airline.name),
              {airline: airline.name, inbound: [], outbound: [], current: false},
            ];
            setJalHasNoFlight(true);
          }
          break;
        default:
          break;
      }

      // ★**1 社ぶん終わるたびに反映する**（2026-09-03 再レビュー R1 の副作用修正）。
      //   フライト検索は ANA → JAL の直列なので、ループ終了後にまとめて反映すると
      //   **JAL が返るまで（混雑時は最長 120 秒）ANA の便も表示されない**。
      applyFlightEntities(_currentFlightEntities);

    }

    // ★ループの最終結果をもう一度反映する（2026-09-03 再レビュー R1）。
    //   §1-4 で `updateCurrentFlightEntities` が**新しい配列**を返す形になったため、
    //   反映しないと state は `[]` のままになる（以前は state 配列への push＝
    //   破壊的更新で偶然反映されていた）。空のままだと
    //     - `SectionFlight` に空配列が渡り便が表示されない
    //     - 便の変更が `[]` を map して選択が消える
    //     - フライト検索 effect のガード（`currentFlightEntities.length === 0`）が常に真になり、
    //       `searchParams` が変わるたびに上流のフライト検索が再実行される（上流コール増）
    applyFlightEntities(_currentFlightEntities);

    // ------------------------------------------------------------------
    // ★再読み込みを出す条件（issue #2992 / 2026-09-04 T3 の条件変更）
    //
    //   A. 全社とも 0 便 かつ errors あり → 区画全体を再読み込み表示に置き換える
    //   B. 1 社だけ 0 便 かつ errors あり（もう 1 社は便あり）→ その社のタブ内だけに出す
    //   C. 便は取れているが errors あり（経由便・クラス J の 1 単位だけ失敗）→ **何も出さない**
    //   D. errors なしで 0 便（該当便なし）→ 従来どおり「運航している便がございません」
    //
    //   以前は errors が 1 件でもあれば区画に案内を出していたため、**便が並んでいるのに**
    //   再読み込みが出て紛らわしかった（C）。
    // ------------------------------------------------------------------
    if (airlineResults.length > 0) {
      // 検索していない社（B の再読み込みで 1 社だけ引いたとき）の状態は引き継ぐ
      const nextAirlineErrors: {[airline: string]: {retryAfterSec: number}} = {...flightAirlineErrors};
      airlineResults.forEach((r) => {
        if (!r.hasFlights && r.hadError) {
          nextAirlineErrors[r.airline] = {retryAfterSec: r.retryAfterSec};
        } else {
          // 便が取れた（C）／errors なしの 0 便（D）はどちらも案内を出さない
          delete nextAirlineErrors[r.airline];
        }
      });

      const failedAirlines = Object.keys(nextAirlineErrors);
      // 「便あり」は最終的な entities で見る（1 社だけ引き直したときも他社の便を見落とさない）
      const anyHasFlights = _currentFlightEntities.some(
          (e) => e.inbound.length > 0 && e.outbound.length > 0);

      if (failedAirlines.length > 0 && !anyHasFlights) {
        // A: どの社も便を出せていない
        setFlightError({
          retryAfterSec: failedAirlines.reduce(
              (max, a) => Math.max(max, nextAirlineErrors[a].retryAfterSec), 0),
        });
        setFlightAirlineErrors({});
      } else {
        // B（failedAirlines あり）／C・D（無し）
        setFlightError(undefined);
        setFlightAirlineErrors(nextAirlineErrors);
      }
    }
  }

  /**
   * フライト区画だけを再要求する（issue #2992・レビュー指摘）。
   * ★ページ全体を読み直さない。
   */
  const retryFlights = () => {
    touchSession();
    setFlightError(undefined);
    setFlightAirlineErrors({});
    setLoadingFlight((prevState) => ({...prevState, all: true}));
    (async () => {
      // ★空配列から作り直す（§1-4）。現在値から積むと同じ航空会社が重複する
      setCurrentFlightEntities([]);
      try {
        await updateFlights(undefined, searchParams, []);
      } catch (error) {
        // ★失敗しても案内とローディングを戻す（2026-09-07 再レビュー）
        devLog(error);
        setFlightError({retryAfterSec: DEFAULT_FLIGHT_RETRY_AFTER_SEC});
      } finally {
        setLoadingFlight((prevState) => ({...prevState, all: false}));
      }
    })();
  };

  /**
   * 1 社だけ便を取り直す（条件 B の再読み込み）。 issue #2992 / 2026-09-04
   * ★もう 1 社の便と選択状態は維持する。起点は「対象社を除いた現在の entities」。
   */
  const retryFlightAirline = (airline: string) => {
    touchSession();
    setFlightAirlineErrors((prevState) => {
      const next = {...prevState};
      delete next[airline];
      return next;
    });
    // ★対象社のフラグだけ立てる（`all` を立てると区画全体がローディング表示になり、
    //   取れているもう 1 社の便まで隠れる。2026-09-04 再レビュー F2）
    setLoadingFlight((prevState) => ({
      ...prevState,
      ANA: airline === "ANA" ? true : prevState.ANA,
      JAL: airline === "JAL" ? true : prevState.JAL,
    }));
    (async () => {
      const base = currentFlightEntitiesRef.current.filter((entity) => entity.airline !== airline);
      try {
        await updateFlights(undefined, searchParams, base, airline);
      } catch (error) {
        // ★失敗しても再読み込みボタンを戻す（F2）。消えたままだと利用者は
        //   ページ全体を読み直すしかなくなり、上流コールが再発生する
        devLog(error);
        setFlightAirlineErrors((prevState) => ({
          ...prevState,
          [airline]: {retryAfterSec: DEFAULT_FLIGHT_RETRY_AFTER_SEC},
        }));
      } finally {
        setLoadingFlight((prevState) => ({
          ...prevState,
          ANA: airline === "ANA" ? false : prevState.ANA,
          JAL: airline === "JAL" ? false : prevState.JAL,
        }));
      }
    })();
  };

  const updateCurrentFlightEntities = (flights: { inbound: flightEntity, outbound: flightEntity }, airline: string, notUpdateFlight: {action: string, airline: string, currentFlights:FReservationFlight[]} | undefined, _currentFlightEntities: currentFlightEntity[], useAirline?: string): currentFlightEntity[] => {
    if (!notUpdateFlight) {
      const useCurrentAirline = useAirline === 'all' ? 'ANA' : useAirline;
      const inboundFlights = flights.inbound.flights[flights.inbound.cheepsIndex].FReservationFlight;
      const outboundFlights = flights.outbound.flights[flights.outbound.cheepsIndex].FReservationFlight;
      let current = false;
      // 既存のエンティティに有効なフライトがあるかチェック
      const hasValidCurrentFlight = _currentFlightEntities.some(entity =>
        entity.inbound.length > 0 && entity.outbound.length > 0
      );
      // ★他社が既に選択中なら奪わない（2026-09-04 T3）。
      //   1 社だけ引き直したとき（条件 B）に current が 2 件になり、
      //   `getSelectedFlights` が往復 2 組を返して予約データに便が二重に入る
      const hasCurrentAlready = _currentFlightEntities.some(
          (entity) => entity.current && entity.airline !== airline);
      if (!hasCurrentAlready && airline === useCurrentAirline && inboundFlights.length > 0 && outboundFlights.length) {
        current = true;
      } else if (!hasCurrentAlready && !hasValidCurrentFlight && inboundFlights.length > 0 && outboundFlights.length) {
        current = true;
      }
      // ★同じ航空会社が既にあれば置き換える（§1-4 の保険）。
      //   push だけだと再取得のたびに ANA/JAL が増え、予約データに往復 2 組入る
      const withoutSameAirline = _currentFlightEntities.filter((e) => e.airline !== airline);
      withoutSameAirline.push({
        airline: airline,
        inbound: [flights.inbound.flights[flights.inbound.cheepsIndex].FReservationFlight[0]],
        outbound: [flights.outbound.flights[flights.outbound.cheepsIndex].FReservationFlight[0]],
        current: current
      })
      return withoutSameAirline;

    } else {
      const updateCurrentFlightEntities = _currentFlightEntities.map((flightEntities) => {
        if (notUpdateFlight && flightEntities.airline === airline && flightEntities.airline === notUpdateFlight.airline) {
          return {
            ...flightEntities,
            inbound: notUpdateFlight.action === 'inbound'?  notUpdateFlight.currentFlights : flights.inbound.flights[flights.inbound.cheepsIndex].FReservationFlight,
            outbound: notUpdateFlight.action === 'outbound'? notUpdateFlight.currentFlights : flights.outbound.flights[flights.outbound.cheepsIndex].FReservationFlight,
            current: flightEntities.airline === currentAirline,
          };
        } else if (flightEntities.airline === airline)  {
          return {
            ...flightEntities,
            inbound: flights.inbound.flights[flights.inbound.cheepsIndex].FReservationFlight,
            outbound: flights.outbound.flights[flights.outbound.cheepsIndex].FReservationFlight,
            current: flightEntities.airline === currentAirline,
          };
        }
        return {
          ...flightEntities,
          current: flightEntities.airline === currentAirline,
        };
      });
      setCurrentFlightEntities([...updateCurrentFlightEntities]);

      return updateCurrentFlightEntities;
    }

  }

  /**
   * 選択航空会社変更
   * @param airline
   */
  const changeAirportCallback = (airline: string) => {
    setCurrentAirline(airline);
    const updateFlightEntities = currentFlightEntities.map((flightEntities)=> {
      return {
        ...flightEntities,
        current: flightEntities.airline === airline,
      }
    });
    setCurrentFlightEntities([...updateFlightEntities]);
    const selectFlights = getSelectedFlights(updateFlightEntities);
    setPlanSelectFormData((prevState) => ({
      ...prevState,
      flight: selectFlights,
    }))
  }

  /**
   * 選択フライト変更
   * @param airline
   * @param action
   * @param currentFlights
   * @param airport
   */
  const handleFlightSelectCallback = (airline:string, action:string, currentFlights:FReservationFlight[], airport: string | null | undefined ) => {
    touchSession(); // 便の確定も「操作」（§1-5）
    // 到着空港が変更の場合は更新
    if (isChangeAirport(searchParams, action, airport)) {
      setLoadingFlight({all: true, ANA: true, JAL: true});
      const search = searchParams;
      search.from = airport ?? searchParams.from;
      setSearchParams({...search});

      (async () => {
        try {
          await updateFlights({airline: airline, action: action, currentFlights: currentFlights}, search);
        } catch (error) {
          // ★失敗しても案内とローディングを戻す（2026-09-07 再レビュー）
          devLog(error);
          setFlightError({retryAfterSec: DEFAULT_FLIGHT_RETRY_AFTER_SEC});
        } finally {
          // ここは 3 社ぶん立てているので全部戻す
          setLoadingFlight({all: false, ANA: false, JAL: false});
        }
      })();
    } else {
      const updateFlightEntities = currentFlightEntities.map((flightEntities)=> {
        if (flightEntities.airline === airline) {
          if (action === 'inbound') {
            return {
              ...flightEntities,
              inbound: currentFlights,
              current: flightEntities.airline === airline,
            }
          } else {
            return {
              ...flightEntities,
              outbound: currentFlights,
              current: flightEntities.airline === airline,
            }
          }
        }

        return flightEntities
      });
      setCurrentFlightEntities([...updateFlightEntities]);
      const selectFlights = getSelectedFlights(updateFlightEntities);
      setPlanSelectFormData((prevState) => ({
        ...prevState,
        flight: selectFlights,
      }))
    }
  }

  /**
   * ホテル検索（初回）
   */
  useEffect(() => {
    /**
     * ホテル情報取得
     */
    if (sellerInfo !== undefined && searchParams !== undefined && actionHotel) {
      let target = sellerInfo.hotelSettings.target;
      let code = sellerInfo.hotelSettings.hotelCode;
      const hotelAreaCode = getHotelAreaCode(planSelectFormData);

      // 基本プランに商品が設定されている場合、商品のデータを使用する
      if (planSelectFormData.sellerProduct) {
        target = planSelectFormData.sellerProduct.hotelSettings.target;
        code = planSelectFormData.sellerProduct.hotelSettings.hotelCode;
      }

      // ホテル（宿泊施設）
      if (hotelAllData.currentPage === 0) {
        let searchSort = 1;
        if (target === 'ホテル指定') {
          searchSort = getHotelSort(planSelectFormData?.sellerProduct?.hotelSettings.sort ?? '');
        }

        setHotelSearchParams((prevState) => ({
          ...prevState,
          search_sort: searchSort
        }))
        // ★初回表示のホテル一覧取得を 0〜3 秒ランダムに遅らせる（issue #2992 / 報告書 §8 No.4）。
        //   発売直後は全員がほぼ同時にこのページへ到達し、同じ瞬間に OTS へ突入する。
        //   ずらしても1人あたりの待ちは最大3秒で、上流のピーク同時数を平らにできる。
        const initialDelayMs = Math.floor(Math.random() * 3000);
        // ★タイマーを ref に持ち、アンマウント時に止める（issue #2992・レビュー指摘）。
        //   3 秒以内に画面遷移すると、不要な検索と遷移後の state 更新が走る
        if (initialHotelTimerRef.current) {
          clearTimeout(initialHotelTimerRef.current);
        }
        initialHotelTimerRef.current = setTimeout(() => {
          searchHotelList({
            area_code: hotelAreaCode,
            target: target,
            code: code,
            query: searchParams,
            paged: 1,
            search_sort: searchSort,
          });
        }, initialDelayMs);
      }
    }
  }, [actionHotel]);

  /**
   * 基本料金計算処理実行
   */
  useEffect(() => {
    if (hotelAllData && canSelect && canFlight) {
      updateBasicTotalPrice();
    }
  },[hotelAllData, canSelect, planSelectFormData.flight, canFlight, planSelectFormData.hotel, planSelectFormData.activity])

  /**
   * 基本料金更新処理
   */
  const updateBasicTotalPrice = () => {
    if (canSelect && planSelectFormData.flight && planSelectFormData.flight.length > 0 && planSelectFormData.hotel.length > 0) {
      const total = defaultBasicTotalPrice(planSelectFormData);
      if (total > 0) {
        setPlanSelectFormData((prevState) => ({...prevState, basicPriceTotal:total}))
        setLoadingHotel(false);
      }
    } else if (canSelect && (!planSelectFormData.hotel || planSelectFormData.flight.length === 0)) {
      setIsNotFound(true)
    }
  }

  /**
   * 基本プラン(アクティビティ)設定更新
   * @param acts
   */
  const setActivityCallBack = (acts: IActivity[]) => {
    setActivities(acts)
    setActivityStockExist(checkActivityStockExist(acts));
    setPlanSelectFormData((prevState) => ({...prevState, activity:acts}))
    const active = acts.filter((item) => item.active === true);
    const planTotal = getPlansTotalPrice(acts, planSelectFormData);

    setPlanSelectFormData((prevState) => ({...prevState, planTotal:planTotal}))
    // フライト非表示解除チェック
    let activeSelectCheck = false
    const noSelectActivity = acts.find((activity) => {
      return !activity.active && hasActivityStock(activity)
    })
    // 読み込み中のアクティビティがないかチェック
    const loadingActivity = acts.find((activity) => {
      return activity.loading
    });
    if (!noSelectActivity && !loadingActivity) {
      activeSelectCheck = true;
    }
    setCanSelect(activeSelectCheck)
  }

  const [activityStockExist, setActivityStockExist] = useState(true);

  /**
   * 予約 確認・変更画面に遷移
   * @param planSelectFormData
   */
  const handleMove = (planSelectFormData:PlanSelectFormData) => {
    /**
     * 基本料金設定（データが変更されるたびに再計算）
     */
    if (planSelectFormData.flight.length > 0 && planSelectFormData.hotelTotal > 0) {
      const total = defaultBasicTotalPrice(planSelectFormData);
      if (total > 0) {
        setPlanSelectFormData((prevState) => ({...prevState, basicPriceTotal:total, searchParams: searchParams}))
        planSelectFormData.basicPriceTotal = total;
        planSelectFormData.searchParams = searchParams;
      }
    }

    // ★読み込み中は次のページへ進めない（2026-09-07）。
    //   表示側でも選択を止めているが、最後の砦としてここでも見る
    //   （古いプラン・便のまま確定されるのを防ぐ）
    if (isLoadingComprehenshive || isLoadingFlight.all) {
      return;
    }

    if(planSelectFormData.hotel.length > 0 && planSelectFormData.hotel[0].plan !== undefined) {
      // ★戻り値を見る（2026-09-03 レビュー §1-9）。false のときは checkSession が
      //   打ち切り先へ遷移しているので、そのまま次の画面へ進めてはいけない
      if (!checkSession(planSelectFormData)) {
        return;
      }
      // ★フォームへ進む時点で手続き時間を取り直す（2026-09-04）。
      //   - サーバー: 入場トークンの絶対上限を 1 回だけ延ばす（プラン 60 分 ＋ フォーム 60 分）。
      //     失敗しても遷移は止めない（待合室 OFF なら何も起きない）
      //   - フロント: `sessionStartedAt` を今にして、絶対上限をフォーム基準にする。
      //   これが無いと、プラン選択に時間をかけた人がフォームの記入中に打ち切られる
      planSelectFormData.sessionStartedAt = dayjs().format();
      extendSession();
      navigate(langPath(i18n.language)+"/planselectconfirm", { state: {
        data: planSelectFormData
      } })
    }
  }

  /**
   * 並び順を指定してホテル検索
   * @param type 
   * @param val 
   * @param areaCode 
   * @param hotelType 
   */
  const hotelSort = (type: string, val: number) => {
    if (isLoadingHotel) {
      return;
    }
    if (sellerInfo !== undefined && searchParams !== undefined) {
      const hotelAreaCode = getHotelAreaCode(planSelectFormData);
      const hotelSearchParams = {
        sort: 1,
        target: sellerInfo.hotelSettings.target,
        code: sellerInfo.hotelSettings.hotelCode,
        searchKeyWordType: '',
        searchKeyWordMode: 1,
        searchKeyWordCode: '',
        searchHotelType: '',
      }
      switch (type) {
        case "max_price":
          hotelSearchParams.sort = 2;
          break;
        case "min_price":
          hotelSearchParams.sort = 1;
          break;
        case "recommend":
          hotelSearchParams.sort = 0;
          break;
        default:
          break;
      }

      // 基本プランに商品が設定されている場合、商品のデータを使用する
      if (planSelectFormData.sellerProduct) {
        hotelSearchParams.target = planSelectFormData.sellerProduct.hotelSettings.target;
        hotelSearchParams.code = planSelectFormData.sellerProduct.hotelSettings.hotelCode;
      }

      setHotelSearchParams((prevState) => ({
          ...prevState,
        areaCode: hotelAreaCode,
        area_code: hotelAreaCode,
        target: hotelSearchParams.target,
        code: hotelSearchParams.code,
        search_sort: hotelSearchParams.sort,
        search_keyword_type: hotelSearchParams.searchKeyWordType,
        search_keyword_mode: hotelSearchParams.searchKeyWordMode,
        search_keyword_code: hotelSearchParams.searchKeyWordCode,
        search_hotel_type_code: hotelSearchParams.searchHotelType,
        paged: 1
        }))
      setLoadingHotel(true);
      setActionInitHotel(true);
      setHotelAllData((prevState) => ({
        ...prevState,
        hotelList: []
      }))
      hotelController.abort();

    }
  };

  const [hotelController, setHotelController] = useState(new AbortController())
  /**
   * ホテル一覧検索
   */
  const searchHotelList = async (
    searchQuery: hotelSearchQuery,
  ) => {
    setLoadingHotel(true);
    // 再読み込み用に直近の検索条件を覚えておく（issue #2992 / 報告書 §8 No.4）
    lastHotelQueryRef.current = searchQuery;
    const abortController = new AbortController()
    // ★成功したときだけローディングを維持する（料金確定後に updateBasicTotalPrice が解除する）。
    //   失敗・該当なしで解除し忘れると、SectionStay の再読み込みボタンが
    //   `isLoading` で永久に disabled になる（issue #2992・レビュー指摘）。
    let keepLoading = false;
    try {
    const fetched = await getHotel(abortController, searchQuery);

    // 利用者の操作による中断は障害でも該当なしでもない。表示を変えない
    if (fetched.aborted) {
      return;
    }

    // ★上流障害は「検索結果なし」と区別する（issue #2992 / 報告書 §8 No.4）。
    //   従来は SearchNotFound（該当なし）が出ており、利用者は条件を変えて検索し直して
    //   そのたびに上流コールを再発生させていた。
    if (fetched.isUpstreamError) {
      setHotelError({retryAfterSec: fetched.retryAfterSec ?? 0});
      setIsNotFound(false);
      return;
    }
    setHotelError(undefined);

    const hotelResult = fetched.data;
    const updatePlanSelectFormData = planSelectFormData;
    if (hotelResult && hotelResult?.hotelList.length > 0) {
      updatePlanSelectFormData.isHotels = true;
      const firstHotelIndex = hotelResult.hotelList.findIndex((hotelList) => {
        return hotelList.sold_out_flg !== 1;
      })
      updatePlanSelectFormData.hotel = [
        {
          useDate: searchParams.checkin,
          detail: hotelResult.hotelList[firstHotelIndex],
          checkIn: searchParams.checkin,
          checkOut: searchParams.checkout,
          area: hotelResult.hotelList[firstHotelIndex]?.sub_area_code ?? "",
          total: hotelResult.hotelList[firstHotelIndex]?.min_price ?? 0,
          language_code: i18n.language
        },
      ];
      updatePlanSelectFormData.hotelData = hotelResult.hotelList;
      setPlanSelectFormData((prevState) => ({
        ...prevState,
        isHotels: updatePlanSelectFormData.isHotels,
        hotelData: updatePlanSelectFormData.hotelData,
        hotel: updatePlanSelectFormData.hotel,
        hotelTotal: updatePlanSelectFormData.hotel[0]?.detail?.min_price ?? 0,
      }));
      
      setHotelAllData({...hotelResult});
      setIsNotFound(false);
      keepLoading = true; // 料金確定まではローディング表示のまま（既存挙動）
    } else {
      setIsNotFound(true);
    }
    } finally {
      if (!keepLoading) {
        setLoadingHotel(false);
      }
    }
  };

  /**
   * ホテル一覧の再読み込み（区画別・issue #2992 / 報告書 §8 No.4）。
   * ★ページ全体ではなく「失敗した区画だけ」を再要求する。
   *   ページ全体を再読み込みすると 1人あたり約20回の上流コールが再発生する（2026-08-31 実測）。
   */
  const retryHotelList = () => {
    touchSession();
    if (!lastHotelQueryRef.current) {
      return;
    }
    setHotelError(undefined);
    searchHotelList(lastHotelQueryRef.current);
  };
  
  /**
   * 操作があったことを記録する（2026-09-03 レビュー §1-5）。
   *
   * ★`timestamp` はプランページ到達時にしか設定されず、次に更新されるのは「次へ」の
   *   `checkSession`。プランページで 30 分以上かけて選ぶと、「次へ」で idle 超過と判定されて
   *   打ち切られる。ホテル確定・フライト確定・区画再読み込みでも更新する。
   *   `sessionStartedAt`（絶対上限の起点）は触らない。
   */
  const touchSession = () => {
    planSelectFormData.timestamp = dayjs().format();
  };

  const updateSelectedHotel = (selectedHotel: selectHotelDetail) => {
    touchSession();
    const updateHotel: PlanSelectFromHotelType[] = [
      {
        useDate: searchParams.checkin,
        detail: selectedHotel,
        checkIn: searchParams.checkin,
        checkOut: searchParams.checkout,
        area: selectedHotel?.sub_area_code ?? "",
        total: selectedHotel?.min_price ?? 0,
        language_code: i18n.language
      },
    ];
    setPlanSelectFormData((prevState) => ({
      ...prevState,
      hotel: updateHotel,
      hotelTotal: updateHotel[0]?.detail?.min_price ?? 0,
    }));
  }
  
  useEffect(() => {
    if (actionInitHotel) {
      if (hotelAllData.hotelList.length > 0) {
        setHotelAllData((prevState) => ({
          ...prevState,
          hotelList: [],
        }));
      } else {
        setActionInitHotel(false);
        // ホテル一覧検索
        searchHotelList(updateHotelSearchParams);
      }
    } else if (hotelAllData.hotelList.length > 0 && hotelAllData.currentPage !== hotelAllData.totalPage) {
      addHotelList();
    } else {
      setIsListLoading(false);
    }
  }, [hotelAllData])

  const abortController = new AbortController()
  const addHotelList = () => {
    (async () => {
      if ( hotelAllData.totalPage > 1) {
        setIsListLoading(true)
        if (sellerInfo !== undefined && searchParams !== undefined) {
          const paged = hotelAllData.currentPage + 1;
          const hotelAreaCode = getHotelAreaCode(planSelectFormData);
          let target = sellerInfo.hotelSettings.target;
          let code = sellerInfo.hotelSettings.hotelCode;

          // 基本プランに商品が設定されている場合、商品のデータを使用する
          if (planSelectFormData.sellerProduct) {
            target = planSelectFormData.sellerProduct.hotelSettings.target;
            code = planSelectFormData.sellerProduct.hotelSettings.hotelCode;
          }

          setHotelController(abortController);
          updateHotelSearchParams.area_code = hotelAreaCode;
          updateHotelSearchParams.target = target;
          updateHotelSearchParams.code = code;
          updateHotelSearchParams.query = searchParams;
          updateHotelSearchParams.paged = paged;
          // ホテル一覧検索
          const fetchedMore = await getHotel(
            abortController,
            updateHotelSearchParams);
          // 追加読み込みの失敗は一覧を消さず、区画のエラー表示だけ出す（issue #2992）
          if (fetchedMore.isUpstreamError) {
            setHotelError({retryAfterSec: fetchedMore.retryAfterSec ?? 0});
          }
          const hotelResult = fetchedMore.data;
          if (hotelResult && hotelResult?.hotelList.length > 0 && hotelAllData?.hotelList){
            const updateHotelList = [...hotelAllData?.hotelList].concat(hotelResult?.hotelList);
            setHotelAllData((prevState) => ({
              ...prevState,
              hotelList: updateHotelList,
              currentPage: hotelResult.currentPage
            }))
            setPlanSelectFormData((prevState) => ({
              ...prevState,
              hotelData: updateHotelList,
            }));
          }
          // scrollToHotelSection(); // `宿泊の選択`の場所にスクロールする
        }
        
        setIsListLoading(false);
      }
    })();
  }

  // ★待機画面。順番が来るまで本体（＝上流を叩く画面）を描画しない。
  //   ここで本体を描いてしまうと、待っている人が全員 /plan や /hotel を叩くことになり
  //   待合室の意味がなくなる（issue #2992 / 報告書 §8 No.11）
  if (waitingRoom.isWaiting) {
    return (
      // ★`mainClass` で待機画面だけ縦中央寄せにし、`.l-page-content` の下 80px を消す。
      //   残すと上 40px・下 120px になって上下が揃って見えない
      <MainTemplate
        title={getHeadTitle(planSelectFormData, undefined)}
        planSelectFormData={planSelectFormData}
        mainClass="l-main--waiting-room"
      >
        <WaitingRoom
          status={waitingRoom.status}
          isError={waitingRoom.isError}
          nextCheckSec={waitingRoom.nextCheckSec}
          admitCountdownSec={waitingRoom.admitCountdownSec}
          updatedAt={waitingRoom.updatedAt}
          onRetry={waitingRoom.retry}
          onEnter={waitingRoom.enterSite}
        />
      </MainTemplate>
    );
  }

  /**
   * ★基本プラン／フライト区画全体を読み込んでいる間は**選択させない**（2026-09-07）。
   *   ホテルを選び切ると次のページへ進めてしまうため、古いプラン・便のまま
   *   確定される恐れがある。区画別の再読み込み（在庫・ホテル・1 社だけのフライト）は対象外。
   */
  const selectDisabled = isLoadingComprehenshive || isLoadingFlight.all;

  return (
    <MainTemplate title={getHeadTitle(planSelectFormData, undefined)} fixedBottom={true} planSelectFormData={planSelectFormData}>
      <div className="bgc-white border-bottom-gray pb-16 pb-24-md">
        <div className="wrap-content-900-no_padding">
          <PartsStep activeStep={1}></PartsStep>
        </div>

        {/* 操作ガイドボタン */}
        {/*<PartsTutorialButton value="component-plan_select" />*/}

        <FreeSpaceSection freeSpaceContent={freeSpaceContent}></FreeSpaceSection>

        <div className="wrap-content-900">
          {/* <!--アラート--> */}
          <div className="box-alert-red-small icon-alert d-n">
            <p className="fz-16">{t("選択した内容、旅行代金をご確認ください")}</p>
          </div>

          {/* 選択中の検索条件 */}
          <p className="fz-12 fz-13-md fw-b mt-0 mt-20-md mb-4">{t("選択中の検索条件")}</p>
          <div className="box-light-gray xsmall">
            <div className="search-result">
              <dl className="search-result-item">
                <dt className="search-result-item-dt">{t("利用空港")}</dt>
                <dd className="search-result-item-dd">
                  <ul className="search-result-item-dd-flight">
                    <li key={"search_from"} className="search-result-item-dd-flight-item">
                      {t(`Airport.${getFlightCodeLabel(searchParams?.from) ?? ""}`)}
                    </li>
                    <li key={"search_to"} className="search-result-item-dd-flight-item">
                      {searchParams?.to && (t(`Airport.${getFlightCodeLabel(searchParams?.to) ?? ""}`))}
                    </li>
                  </ul>
                </dd>
              </dl>

              <dl className="search-result-item">
                <dt className="search-result-item-dt">{t("旅行期間")}</dt>
                <dd className="search-result-item-dd">
                  <ul className="search-result-item-dd-date">
                    <li key={"search_start"} className="search-result-item-dd-date-item">
                      {dateFormat(searchParams?.start, "YYYY/MM/DD", i18n.language)}
                    </li>
                    <li key={"search_end"} className="search-result-item-dd-date-item">
                      {dateFormat(searchParams?.end, "YYYY/MM/DD", i18n.language)}
                    </li>
                  </ul>
                </dd>
              </dl>

              <dl className="search-result-item">
                <dt className="search-result-item-dt">{t("部屋数・人数")}</dt>
                <dd className="search-result-item-dd">
                  {getHotelRoomPeopleLabel(searchParams?.roomDetail, searchParams?.rooms, t)}
                  {/* 1室・4名（大人1/子供3） */}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      {/* 検索ボックス */}
      {isSearchBox && (<TopSearchbox query={searchParams} callbackSearch={handleSearch}></TopSearchbox>)}

      {is500Error && (
        <>
          <Error500></Error500>
        </>
      )}

      {isNotFound && (
        <>
          <SearchNotFound></SearchNotFound>
        </>
      )}

      {!is500Error && !isNotFound && (
        isPlan ? ( // プランあり
          <>
            {planError && !isLoadingComprehenshive ? (
              // ★区画エラーはローダーより優先して出す（§1-2）。
              //   ローダーを先に見ると「読み込み中のまま固まった画面」になる
              <SectionPlan
                activityStockExist={activityStockExist}
                setActivityStockExist={setActivityStockExist}
                planSelectFormData={planSelectFormData}
                activities={activities}
                searchParams={searchParams}
                isLoading={isLoadingComprehenshive}
                setActivities={setActivityCallBack}
                planError={planError}
                onRetryPlan={() => fetchPlan(true)}
              ></SectionPlan>
            ) : searchLoading ? ( // ローディング中の表示
              <div className="mt-32 mt-40-md">
                <div className="wrap-content-900">
                  <LoadingOverlay active={searchLoading}>
                    <div className="pb-100 pt-80"></div>
                  </LoadingOverlay>
                </div>
              </div>
            )
            : activityStockExist ? ( // 選択可能なプランあり
              <>
                {planType !== "option" && (
                  <>
                    {/* 基本プラン */}
                    <SectionPlan
                      // ★再取得のたびに作り直す（§1-3）。`loading` を立て直さないと
                      //   新しいプランの /plan/stocks を引かない（`if (!loading) return` で抜ける）
                      key={`plan-${planFetchCount}`}
                      activityStockExist={activityStockExist}
                      setActivityStockExist={setActivityStockExist}
                      planSelectFormData={planSelectFormData}
                      activities={activities}
                      searchParams={searchParams}
                      isLoading={isLoadingComprehenshive}
                      setActivities={setActivityCallBack}
                      planError={planError}
                      onRetryPlan={() => fetchPlan(true)}
                    ></SectionPlan>
                  </>
                )}

                {/* フライト選択 */}
                {<SectionFlight
                  flightError={flightError}
                  airlineErrors={flightAirlineErrors}
                  onRetryFlightAirline={retryFlightAirline}
                  onRetryFlight={retryFlights}
                  planSelectFormData={planSelectFormData}
                  flights={flightEntities}
                  currentFlightEntities={currentFlightEntities}
                  changeFlightCallback={handleFlightSelectCallback}
                  changeAirportCallback={changeAirportCallback}
                  search={searchParams}
                  isLoading={isLoadingFlight}
                  selectDisabled={selectDisabled}
                  canSelect={canSelect}
                  anaHasNoFlight={anaHasNoFlight}
                  jalHasNoFlight={jalHasNoFlight}
                  profitRate={planSelectFormData?.planData?.sellerIndo.profitRate?? "0"}
                ></SectionFlight>}

                {/* ホテル選択 */}
                <SectionStay 
                  planSelectFormData={planSelectFormData}
                  selectPlan={handleMove}
                  isLoading={isLoadingHotel}
                  // ★プラン・フライト区画全体の読み込み中は**選択だけ**止める。
                  //   `isLoading` に混ぜると、ホテルの再読み込みボタンまで押せなくなる
                  selectDisabled={selectDisabled}
                  isListLoading={isListLoading}
                  canSelect={canSelect}
                  callback={()=> {}}
                  sort={hotelSort}
                  hotelAllData={hotelAllData}
                  hotelController={hotelController}
                  handleHotelSelected={updateSelectedHotel}
                  hotelError={hotelError}
                  onRetryHotel={retryHotelList}
                ></SectionStay>
              </>
            )
            : (<SearchNotFound></SearchNotFound>) // 選択可能なプランなし
            }
            <div className="parts-bottom-fixed">
              <div className="wrap-content-900-no_padding ">
                <div className="box-white fixed-padding">
                  <div className="d-f ai-c jc-sb jc-fe-md">
                    <p className="fw-b pr-24">
                      {t("現在の旅行代金合計")}<br />
                      <span className="fz-12 fw-n">（※{t("申込人数分の総額")}）</span>
                    </p>
                    <p className="fz-24 fz-28-md c-red fw-b">
                      {activityStockExist && planSelectFormData.basicPriceTotal > 0 ? planSelectFormData.basicPriceTotal.toLocaleString() : "--"}
                      <span className="fz-14 fz-16-md">{t("円")}({t("税込")})</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
        : (<ServiceStop></ServiceStop>) // プランなし
      )}
    </MainTemplate>
  );
};

export default PlanSelectPage;
